/** @public @react */
export function DefaultSvgDefs() {
	return null
}
